"use strict";
/** Progressive enhancement only: Shopify owns forms, carts, checkout and accounts. */
const menuButton = document.querySelector('[data-menu]');
menuButton?.addEventListener('click', () => {
    const menu = document.getElementById('mobile-nav');
    if (!menu)
        return;
    menu.hidden = !menu.hidden;
    menuButton.setAttribute('aria-expanded', String(!menu.hidden));
});
document.querySelectorAll('[data-autosubmit]').forEach(select => {
    select.addEventListener('change', () => select.form?.requestSubmit());
});
document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape')
        return;
    const menu = document.getElementById('mobile-nav');
    if (menu && !menu.hidden) {
        menu.hidden = true;
        menuButton?.setAttribute('aria-expanded', 'false');
        menuButton?.focus();
    }
});
const variantSelect = document.querySelector('[data-variant-select]');
variantSelect?.addEventListener('change', () => {
    const price = document.getElementById('VariantPrice');
    if (price)
        price.textContent = variantSelect.selectedOptions[0]?.dataset.price || '';
});
